import React from 'react';
import NewAddress from './delivery_address_new_address';
import AddressBook from './delivery_address_address_book';
import PaymentBillingAddressGuest from './payment_billing_address_guest';

class PaymentCard extends React.Component {
  constructor(props) {
    super(props);
    const { signed_in: signedIn } = this.props;
    this.state = {
      its_payment_url: '',
      display_its_frame: false,
      payment_error: false,
      billing_address: {
        name: '',
        line1: '',
        line2: '',
        line3: '',
        line4: '',
        line5: '',
        postcode: '',
      },
      billing_address_option: signedIn ? 'invoice_address' : 'delivery_address',
      showNewAddressForm: false,
      search_postcode_error: false,
      addresses: [],
      loading: false,
      selectedAddress: {},
      selected: null,
      contact_number: '',
      name: props.name,
      billingSameAsDelivery: false,
      billingDifferentToDelivery: false,
      billingSameAsInvoice: false,
    };

    this.getItsPaymentUrl = this.getItsPaymentUrl.bind(this);
    this.goToContactUs = this.goToContactUs.bind(this);
    this.paymentListener = this.paymentListener.bind(this);
    this.progressToCardDetails = this.progressToCardDetails.bind(this);
    this.reattemptPayment = this.reattemptPayment.bind(this);
    this.showNewAddressForm = this.showNewAddressForm.bind(this);
    this.setBillingAddressAsDeliveryAddress =
      this.setBillingAddressAsDeliveryAddress.bind(this);
    this.setBillingAddressOption = this.setBillingAddressOption.bind(this);
    this.handleSearchPostCodeChange =
      this.handleSearchPostCodeChange.bind(this);
    this.getAddressesFromPostCode = this.getAddressesFromPostCode.bind(this);
    this.handleGuestBillingAddress = this.handleGuestBillingAddress.bind(this);
    this.handleGuestContactNumber = this.handleGuestContactNumber.bind(this);
    this.handleGuestName = this.handleGuestName.bind(this);
    this.handleSignedInpostcodeError =
      this.handleSignedInpostcodeError.bind(this);
  }

  handleSignedInpostcodeError(val) {
    if (val === true) {
      this.setState({ signedInpostcodeError: true });
    }
  }

  paymentListener(event) {
    var domain = window.location.protocol + '//' + window.location.host;
    if (event.origin !== domain) {
      return;
    }
    // if (event instanceof String) {
    if (event.data === 'its-payment-error') {
      this.setState({
        display_its_frame: false,
        payment_error: true,
        billingDifferentToDelivery: false,
      });
      this.props.setPaymentStatus(false);
      this.props.configGenericError({
        title: 'Payment Error',
        body: (
          <div>
            <p>Unfortunately, your payment was not successful.</p>
            <p>No payment has been taken from your card.</p>
            <p>
              We are sorry for any inconvenience this may cause. Please try
              again later. If the problem persists, please contact our customer
              service team.
            </p>
          </div>
        ),
        errorButton: true,
        errorButtonTitle: 'Re-Attempt Payment',
        errorButtonAction: this.reattemptPayment,
        closeAction: this.reattemptPayment,
      });
    } else if (
      !event.data.hasOwnProperty('source') &&
      event.data.indexOf('its-payment-success') == 0
    ) {
      let url = event.data.replace('its-payment-success-', '');
      this.setState({ display_its_frame: false, payment_error: false });
      this.props.completeOrder({
        url,
      });
    }
    // }
  }

  componentDidMount() {
    if (window.addEventListener) {
      window.addEventListener('message', this.paymentListener, false);
    } else {
      window.attachEvent('onmessage', this.paymentListener);
    }

    if (this.props.signed_in === true) {
      this.setBillingAddressAsInvoiceAddress();
      this.setBillingAddressOption('invoice_address');
    } else {
      this.setBillingAddressAsDeliveryAddress();
    }
  }

  setBillingAddressAsDeliveryAddress() {
    const { addressMode, delivery_address } = this.props;
    if (addressMode != 'BRANCH_DELIVERY') {
      this.setState({
        billing_address: {
          name: delivery_address.name,
          line1: delivery_address.line1,
          line2: delivery_address.line2,
          line3: delivery_address.line3,
          line4: delivery_address.line4,
          line5: delivery_address.line5,
          postcode: delivery_address.postcode,
        },
        billingSameAsDelivery: true,
      });
    } else {
      this.setState({
        billingSameAsDelivery: false,
      });
    }
  }

  setBillingAddressAsInvoiceAddress() {
    const { customerInvoiceAddress } = this.props;
    this.setState({
      billing_address: {
        name: customerInvoiceAddress.name,
        line1: customerInvoiceAddress.line_1,
        line2: customerInvoiceAddress.line_2,
        line3: customerInvoiceAddress.line_3,
        line4: customerInvoiceAddress.line_4,
        line5: customerInvoiceAddress.line_5,
        postcode: customerInvoiceAddress.postcode,
      },
      billingSameAsInvoice: true,
    });
  }

  setBillingAddressOption(option) {
    switch (option) {
      case 'delivery_address':
        this.setState({
          billing_address_option: option,
        });
        this.setBillingAddressAsDeliveryAddress();
        this.props.setInvoiceAddress(this.props.delivery_address);
        break;
      case 'invoice_address':
        this.setState({
          billing_address_option: option,
        });
        this.setBillingAddressAsInvoiceAddress();
        this.props.setInvoiceAddress(this.props.customerInvoiceAddress);
        break;
      case 'different_address':
        this.setState({
          billing_address_option: option,
        });
        break;
    }
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.signed_in === true) {
      //check for signed in, delivery not the same as invoice.
      if (nextProps.delivery_address !== this.props.invoice_address) {
        //check for signed in, set billing addresss same as delivery.
        if (this.state.billing_address_option === 'delivery_address') {
          this.setState({ billing_address: nextProps.delivery_address });
        } else if (this.state.billing_address_option === 'invoice_address') {
          this.setBillingAddressAsInvoiceAddress();
        } else {
          //check for signed in, set as new billing address based on either address book or new address form.
          this.setState({ billing_address: nextProps.invoice_address });
        }
      }
    } else {
      //check for guest, same billing as delivery after billing is set.
      if (nextProps.delivery_address !== this.props.delivery_address) {
        this.setState({ billing_address: nextProps.delivery_address }, () => {
          this.props.setInvoiceAddress(this.state.billing_address);
        });
      }
      //check for guest, different billing as delivery on checkout payment panel address select.
      if (nextProps.invoice_address !== this.props.invoice_address) {
        this.setState({ billing_address: nextProps.invoice_address });
      }

      if (nextProps.branchAddressFlag === true) {
        this.setBillingAddressOption('different_address');
      }
    }
  }

  getItsPaymentUrl() {
    $.ajax({
      url: this.props.itsPaymentUrl,
      dataType: 'json',
      success: url => {
        this.props.showDetailErrors(false, []);
        this.setState(
          {
            its_payment_url: url.url,
            display_its_frame: true,
          },
          () => {
            this.props.setPaymentStatus(true);
            if (this.ifr) {
              this.ifr.onload = () => {};
            }
          },
        );
      },
      error: e => {
        this.props.showDetailErrors(true, e.responseText);
        this.setState({
          its_payment_url: '',
          display_its_frame: false,
        });
      },
    });
  }

  progressToCardDetails() {
    $('html, body').animate(
      {
        scrollTop: $('.payment-card-details').offset().top,
      },
      1000,
    );
    if (_.isEmpty(this.state.billing_address) === false) {
      this.getItsPaymentUrl();
    }
  }

  reattemptPayment() {
    this.props.toggleGenericError();
    this.setState({
      payment_error: false,
      display_its_frame: false,
    });
  }

  goToContactUs() {
    window.location.href = '/contact_us';
  }

  showNewAddressForm() {
    if (
      this.state.display_its_frame === true ||
      this.state.billingDifferentToDelivery === true
    )
      return false;
    this.setState({ showNewAddressForm: !this.state.showNewAddressForm });
  }

  handleSearchPostCodeChange(e) {
    this.setState({
      search_postcode: e.target.value,
    });
  }

  getAddressesFromPostCode() {
    this.setState(
      {
        addresses: [],
        loading: true,
        search_postcode_error: false,
      },
      () => {
        $.ajax({
          url: this.props.addressEnquiryUrl,
          method: 'GET',
          dataType: 'json',
          data: {
            postcode: this.state.search_postcode,
          },
          success: data => {
            this.setState({ addresses: data, loading: false });
          },
          error: () => {
            this.setState({
              search_postcode_error: true,
              loading: false,
              addresses: [],
            });
          },
        });
      },
    );
  }

  setGuestBillingAddress(address) {
    let formatted_address = {
      name: `${this.state.name}`,
      line1: address['line_1'],
      line2: address['line_2'],
      line3: address['line_3'],
      line4: address['line_4'],
      line5: address['line_5'],
      postcode: address['postcode'],
    };
    this.setState({
      selected: address,
      selectedAddress: formatted_address,
      billing_address: formatted_address,
    });
  }

  handleGuestContactNumber(e) {
    this.setState({
      telephone: e.target.value,
    });
  }

  handleGuestName(e) {
    this.setState({
      name: e.target.value,
    });
  }

  handleGuestBillingAddress(address) {
    this.setBillingAddressOption('different_address');
    this.props.setInvoiceAddress(address);

    if (this.props.current_step === 'PAYMENT') {
      this.setState({
        billingDifferentToDelivery: true,
        billingSameAsDelivery: false,
        showNewAddressForm: false,
      });
    }
  }

  render() {
    var paymentIFrame = '';
    if (
      !_.isEmpty(this.state.billing_address) &&
      this.state.display_its_frame === true
    ) {
      paymentIFrame = (
        <div>
          <h3>Please enter your card details</h3>
          <iframe
            className="its-frame"
            src={this.state.its_payment_url}
            ref={f => (this.ifr = f)}
          />
        </div>
      );
    }

    var loading =
      this.state.loading === true ? (
        <span className="loading">
          <i className="icon-spinner icon-spin icon-large" />
        </span>
      ) : (
        ''
      );

    var postcodeSearchError =
      this.state.search_postcode_error === true ? (
        <span className="search-postcode--error">
          No Addresses found for postcode
        </span>
      ) : (
        ''
      );

    var showPaymentDisplayError = this.props.show_payment_display_error && (
      <div className="showPaymentDisplayError">
        {this.props.payment_display_errors.map((errorMessage, index) => (
          <p key={index}>{errorMessage}</p>
        ))}
      </div>
    );

    return (
      <div className="checkout-sub-panel payment">
        <div className="accepted-cards">
          <img src={this.props.assets.cards.visa} />
          <img src={this.props.assets.cards.electron} />
          <img src={this.props.assets.cards.mastercard} />
          <img src={this.props.assets.cards.maestro} />
        </div>

        <div className="paypal-payment-summary">
          Your Payment Card will be charged:{' '}
          <strong>&pound;{this.props.paymentTotal}</strong> for your delivery
          items and delivery charge (if applicable).
        </div>

        <h3>Billing Address</h3>

        <div className="fl-on fl-jc-sb">
          {(this.props.addressMode !== 'BRANCH_DELIVERY' ||
            this.props.signed_in === true) && (
            <div className="fl-fb-50">
              <ul
                className={
                  'billing-address-options ' +
                  (this.state.display_its_frame === true ? ' disabled' : '')
                }>
                {this.props.signed_in === true && (
                  <li>
                    <label>
                      <input
                        type="radio"
                        value="invoice_address"
                        disabled={this.state.display_its_frame}
                        onChange={() => {
                          this.setBillingAddressOption('invoice_address');
                        }}
                        checked={
                          this.state.billing_address_option ===
                            'invoice_address' ||
                          ((this.props.addressMode === 'INVOICE_ADDRESS' ||
                            this.props.addressMode === 'BRANCH_DELIVERY') &&
                            this.state.billing_address_option ===
                              'delivery_address')
                        }
                      />
                      <span>Same as invoice address</span>
                    </label>
                  </li>
                )}
                {this.props.branchAddressFlag === false &&
                  this.props.addressMode !== 'INVOICE_ADDRESS' && (
                    <li>
                      <label>
                        <input
                          type="radio"
                          value="delivery_address"
                          disabled={this.state.display_its_frame}
                          onChange={() => {
                            this.setBillingAddressOption('delivery_address');
                          }}
                          checked={
                            this.state.billing_address_option ===
                            'delivery_address'
                          }
                        />
                        <span>Same as delivery address</span>
                      </label>
                    </li>
                  )}
                <li>
                  <label>
                    <input
                      type="radio"
                      value="different_address"
                      disabled={this.state.display_its_frame}
                      onChange={() => {
                        this.setBillingAddressOption('different_address');
                      }}
                      checked={
                        this.state.billing_address_option ===
                        'different_address'
                      }
                    />
                    <span>Use a different billing address</span>
                  </label>
                </li>
              </ul>
            </div>
          )}
          {this.props.signed_in == true ? (
            <div className="fl-fb-50">
              <div className="selected--billing-address">
                <ul>
                  <li>{this.state.billing_address.name}</li>
                  <li>{this.state.billing_address.line1}</li>
                  <li>{this.state.billing_address.line2}</li>
                  <li>{this.state.billing_address.line3}</li>
                  <li>{this.state.billing_address.line4}</li>
                  <li>{this.state.billing_address.line5}</li>
                  <li>{this.state.billing_address.postcode}</li>
                </ul>
              </div>
            </div>
          ) : (
            <PaymentBillingAddressGuest
              billingAddress={this.state.billing_address}
              addressMode={this.props.addressMode}
            />
          )}
        </div>
        {this.state.billing_address_option === 'different_address' ? (
          this.props.signed_in ? (
            <div
              className={
                'postcode-lookup' +
                (this.state.display_its_frame === true ||
                this.state.billingDifferentToDelivery === true
                  ? ' disabled'
                  : '')
              }>
              {!this.state.showNewAddressForm && (
                <div>
                  <AddressBook
                    addresses={this.props.addresses}
                    addressMode={'ADDRESS_BOOK'}
                    current_step={this.props.current_step}
                    setAddressFromAddressBook={
                      this.props.setInvoiceAddressFromAddressBook
                    }
                    selectedAddress={this.props.selectedAddress}
                    signed_in={this.props.signed_in}
                    progressToCardDetails={this.progressToCardDetails}
                    handleGuestBillingAddress={this.handleGuestBillingAddress}
                    disableClick={
                      this.state.display_its_frame === true ||
                      this.state.billingDifferentToDelivery === true
                        ? true
                        : false
                    }
                  />
                  <div className="fl-on fl-sm-on fl-jc-fe fl-sm-jc-fe">
                    <button
                      className="top-margin next-panel"
                      onClick={this.showNewAddressForm}>
                      Enter new address
                    </button>
                  </div>
                </div>
              )}
              <div>
                {this.state.showNewAddressForm && (
                  <div>
                    <NewAddress
                      addressMode={'NEW_ADDRESS'}
                      addressEnquiryUrl={this.props.addressEnquiryUrl}
                      deliveryAddressUrl={this.props.billingAddressUrl}
                      getAddressBook={this.props.getAddressBook}
                      method={'PUT'}
                      current_step={this.props.current_step}
                      setAddressFromAddressBook={
                        this.props.setInvoiceAddressFromAddressBook
                      }
                      setAddressMode={this.props.setAddressMode}
                      telephone={this.props.telephone}
                      signed_in={this.props.signed_in}
                      progressToCardDetails={this.progressToCardDetails}
                      handleSignedInpostcodeError={
                        this.handleSignedInpostcodeError
                      }
                      handleGuestBillingAddress={this.handleGuestBillingAddress}
                    />
                    <div className="fl-on fl-sm-on fl-jc-fe fl-sm-jc-fe">
                      <button
                        className="top-margin next-panel"
                        onClick={this.showNewAddressForm}>
                        Select from Address Book
                      </button>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ) : (
            <div
              className={
                'postcode-lookup' +
                (this.state.display_its_frame === true ||
                this.state.billingDifferentToDelivery === true
                  ? ' disabled'
                  : '')
              }>
              <NewAddress
                addressMode={'NEW_ADDRESS'}
                addressEnquiryUrl={this.props.addressEnquiryUrl}
                deliveryAddressUrl={this.props.billingAddressUrl}
                getAddressBook={this.props.getAddressBook}
                method={'PUT'}
                current_step={this.props.current_step}
                setAddressFromAddressBook={
                  this.props.setInvoiceAddressFromAddressBook
                }
                setAddressMode={this.props.setAddressMode}
                telephone={this.props.telephone}
                signed_in={this.props.signed_in}
                progressToCardDetails={this.progressToCardDetails}
                handleSignedInpostcodeError={this.handleSignedInpostcodeError}
                handleGuestBillingAddress={this.handleGuestBillingAddress}
              />
              {/* <div className="fl-on fl-fd-col">
                <div className="mw-50">
                  Name <strong>*</strong>
                  <input
                    type="text"
                    value={this.state.name}
                    autoComplete="no"
                    disabled={this.state.display_its_frame}
                    onChange={this.handleGuestName}
                  />
                </div>

                <div className="mw-50">
                  Contact Number
                  <input
                    type="text"
                    autoComplete="no"
                    disabled={this.state.display_its_frame}
                    onChange={this.handleGuestContactNumber}
                  />
                </div>
              </div>
              <div className="fl-on fl-fd-col">
                <div className="mw-50">
                  Postcode <strong>*</strong>
                  <br />
                  <input
                    type="text"
                    className="postcode"
                    disabled={this.state.display_its_frame}
                    value={this.state.search_postcode}
                    onChange={this.handleSearchPostCodeChange}
                    autoComplete="no"
                  />
                  <button
                    className="grey-button"
                    disabled={this.state.display_its_frame}
                    onClick={this.getAddressesFromPostCode}
                  >
                    Find Address
                  </button>
                  {postcodeSearchError}
                  {loading}
                </div>
              </div>
              {this.state.addresses.length > 0 && (
                <div>
                  <div className="available--addresses">
                    <ul>
                      {this.state.addresses.map((address, index) => {
                        let className =
                          this.state.selected === address
                            ? "active"
                            : "inactive";
                        return (
                          <li
                            key={index}
                            className={className}
                            onClick={() => {
                              this.setGuestBillingAddress(address);
                            }}
                          >
                            {address.short_name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <div className=" fl-on fl-sm-on fl-jc-fe fl-sm-jc-fe ">
                    <button onClick={this.handleGuestBillingAddress}>
                      Set Address
                    </button>
                  </div>
                </div>
              )} */}
            </div>
          )
        ) : (
          ''
        )}
        {showPaymentDisplayError}
        <div className=" fl-on fl-sm-on">
          <button
            className="top-margin pay-with-card-button next-panel"
            onClick={this.progressToCardDetails}
            disabled={
              this.props.show_payment_display_error ||
              this.state.display_its_frame === true ||
              (this.state.billingSameAsDelivery === false &&
                this.state.billingDifferentToDelivery === false &&
                this.state.billingSameAsInvoice === false) ||
              (this.state.billingSameAsDelivery === true &&
                this.props.branchAddressFlag === true) ||
              (this.state.billing_address_option === 'different_address' &&
                this.state.billingDifferentToDelivery === false)
            }>
            Continue to Card Details
          </button>
        </div>
        <div className="payment-card-details">{paymentIFrame}</div>
      </div>
    );
  }
}

export default PaymentCard;
